import type { Boundary } from '../models/boundaries/boundary.model';
import { wrapRequest } from './base';

const getBoundaries = async (): Promise<Boundary[]> =>
  wrapRequest('get', 'geonius', '/boundaries', {
    queryStringParameters: {
      format: 'vector_tile',
    },
  });

export const getCombinedEEZ = async (): Promise<Boundary[]> =>
  wrapRequest('get', 'geonius', '/boundaries', {
    queryStringParameters: {
      url: 'mapbox://geollectryan.eez_combined',
    },
  });

export const getCombinedJWC = async (): Promise<Boundary[]> =>
  wrapRequest('get', 'geonius', '/boundaries', {
    queryStringParameters: {
      url: 'mapbox://geollectryan.full-jwc-v2',
    },
  });

export const getCombinedTTW = async (): Promise<Boundary[]> =>
  wrapRequest('get', 'geonius', '/boundaries', {
    queryStringParameters: {
      url: 'mapbox://geollectryan.ttw_combined',
    },
  });

export const extractBoundaryTypes = (boundaries: Boundary[]): string[] => {
  const types = [
    ...new Set(boundaries.map((boundary) => boundary.boundary_type)),
  ].sort();

  const reorganisedTypes = types.includes('Other')
    ? types.filter((type) => type !== 'Other').concat('Other')
    : types;
  return reorganisedTypes;
};

export const fetchAndCombineBoundaries = async (): Promise<{
  boundaries: Boundary[];
  boundaryTypes: string[];
}> => {
  const boundariesData = await getBoundaries();
  return {
    boundaries: boundariesData,
    boundaryTypes: [],
  };
};

export const COMBINEDBOUNDARIESURLS = [
  'mapbox://geollectryan.eez_combined',
  'mapbox://geollectryan.full-jwc-v2',
  'mapbox://geollectryan.ttw_combined',
];
